exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".node[data-v-445d3316]{cursor:pointer}.font[data-v-445d3316]{pointer-events:none;fill:#fff;color:#fff}", ""]);

// exports
